import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';

export default function Body() {
    return (
        <div className="text-primary text-center text-2xl">
            Home Page
            <ol className="justify-center text-xl text-secondary">
                <li>
                    <Link to={paths.about}>Go to About Page</Link>
                </li>
                <li>
                    <Link to={paths.contact}>Go to Contact Page</Link>
                </li>
            </ol>
        </div>
    )
}
